import Vue from 'vue'
import http from '../utils/http';

export default {
    state: {
        advancedFeatures: [],
    },
    mutations: {
        loadAllFeatures(state, payload) {
			state.advancedFeatures = payload
		},
        addFeature(state, payload) {
           const index = state.advancedFeatures.length
			Vue.set(state.advancedFeatures, index, payload)   
        },
        editFeature(state, payload) {
            const seg = state.advancedFeatures.find(s => s.id == payload.id)
            const index = state.advancedFeatures.indexOf(seg)
			Vue.set(state.advancedFeatures, index, payload)   
        },
        deleteFeature(state, payload) {
            state.advancedFeatures =  state.advancedFeatures.filter(feat => feat.id !== payload)
        }
    },
    actions: {
        async fetchAdvancedFeatures({ commit }, payload) {
            commit('clearError')
            commit('setLoading', true)

            try {
                const result = await http.get(`/advanced-features/${payload.gameId}?round=${payload.round}`);
                
                if (result) {
                   const advancedFeatures = await result.data 
                   commit('loadAllFeatures', advancedFeatures)
                }
                               
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
                commit('setLoading', false)
                throw error
            } 
        },
        async addAF({ commit }, payload) {
            commit('clearError')
            commit('setLoading', true)

            let segment = {};

            if (payload.segment_name) {
                segment.name = payload.segment_name;
                delete payload.segment_name;
            }

            try {
                const result = await http.post(`/advanced-features`, payload);
                if (result) {
                   const af = await result.data
                   af.segment = segment 
                   commit('addFeature', af)
                }
                               
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
                commit('setLoading', false)
                throw error
            } 
        },
        async editAF({ commit }, payload) {
            commit('clearError')
            commit('setLoading', true)

            const segment = {}
            if (payload.segment) {
                segment.name = payload.segment.name;
                delete payload.segment;
            }

            try {
                await http.put(`/advanced-features/${payload.id}`, payload);
                
                payload.segment = segment;

                commit('editFeature', payload)            
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
                commit('setLoading', false)
                throw error
            } 
        },
        async deleteAF({ commit }, payload) {
            commit('clearError')
            commit('setLoading', true)

            try {
                const result = await http.delete(`/advanced-features/${payload}`);
                console.log(result)
                commit('deleteFeature', payload)            
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
                commit('setLoading', false)
                throw error
            } 
        },
        async calculateAcceptance({ commit }, payload) {
            commit('clearError')
            commit('setLoading', true)

            try {
                const result = await http.get(`/advanced-features/acceptance/${payload.gameId}?round=${payload.round}`);
                
                if (result) {
                   const advancedFeatures = await result.data 
                   commit('loadAllFeatures', advancedFeatures)
                }
                               
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
                commit('setLoading', false)
                throw error
            } 
        },
        async advancedFeatureTransition({ commit }, payload) {
            commit('clearError')
            commit('setLoading', true)

            try {
                await http.get(`/advanced-features/transition/${payload.gameId}?round=${payload.round}`);         
                commit('setLoading', false);
            }
            catch(error) {
                commit('setError', error.message)
                commit('setLoading', false)
                throw error
            } 
        },
    },
    getters: {
        advancedFeatures(state) {
            return state.advancedFeatures;
        },
    }
}